<template>
  <div class="cancel-order-dialog">
    <StatusDialog
      :visible.sync="dialogVisible"
      type="warning"
      :width="500"
      @close="onClose"
    >
      <h3 class="status-dialog__title">取消订单</h3>
      <p class="status-dialog__desc">订单号：{{ orderNo }}</p>
      <!-- <div class="cancel-order-dialog__info">
        <label>订单号：</label>
        <span>{{ orderNo }}</span>
      </div> -->
      <div class="status-dialog__footer">
        <el-button
          class="indiv-btn cancel-order-dialog__confirm"
          type="primary"
          :loading="cancelling"
          @click="onConfirm"
        >
          确定取消
        </el-button>
      </div>
    </StatusDialog>
  </div>
</template>

<script>
export default {
  name: 'CancelOrderDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
    cancelling: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    orderNo() {
      return (this.order && this.order.orderNo) || '—';
    },
  },

  methods: {
    onClose() {
      if (!this.cancelling) {
        this.$emit('close');
      }
    },
    onConfirm() {
      if (this.cancelling) return;
      this.$emit('confirm');
    },
  },
};
</script>

<style scoped>
.cancel-order-dialog__info {
  margin: 0 0 32px;
  padding: 16px 20px;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  background: #f9fbff;
  border-radius: 8px;
}

.cancel-order-dialog__info label {
  color: #525252;
  font-weight: 400;
}

.cancel-order-dialog__info span {
  color: #000;
  word-break: break-all;
}

.cancel-order-dialog >>> .popContainer.status-dialog .status-dialog__footer .cancel-order-dialog__confirm.el-button.indiv-btn {
  min-width: 180px;
  height: 48px;
  padding: 0 32px;
  font-size: 14px;
  border-radius: 999px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/client/personal-center/panels/MyOrders/CancelOrderDialog.vue